import React from 'react'
import PageContent from 'components/common/PageContent'
import AgentsTable from 'components/organisation/agents/AgentsTable'

export default function Agents(props) {

    const pathElements = [
        {id: 0, title: "Home", url: "/"},
        {id: 1, title: "Organisation", url: "/organisation"},
        {id: 2, title: "Agents"}
    ];

    return (
        <PageContent pathElements={pathElements}>
            <AgentsTable {...props} />
        </PageContent>
    )
}
